import { render, staticRenderFns } from "./IconPoiRestaurant.vue?vue&type=template&id=4234cd1e&"
import script from "./IconPoiRestaurant.vue?vue&type=script&lang=js&"
export * from "./IconPoiRestaurant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports